export interface NormalizedTransactions {
  list: any[];
  count: number;
  degraded: boolean;
}

/**
 * Coage a resposta de `getTransactions` para uma forma sempre renderizável.
 *
 * Necessário porque o funil de request (`createDocumentRequest`) só classifica
 * 500/403 e 400/401/403/404/410/429 como erro: 502/503/504 caem no ramo
 * `type: 'success'` com o body HTML do gateway virando `{ isJSON: false }`, e
 * 204/202 retornam sem `data` (=> `undefined`). Nenhum dos dois casos é
 * reconhecido por `unwrapOrToast`, então o fallback `{ list: [] }` não engata e
 * o payload inválido chega ao render.
 *
 * `degraded: true` sinaliza que a resposta não tinha a forma esperada, para o
 * chamador avisar o usuário em vez de exibir uma lista vazia como se fosse um
 * resultado real.
 */
export function normalizeTransactionsResponse(
  raw: unknown,
): NormalizedTransactions {
  const isObject = typeof raw === 'object' && raw !== null;
  const list = isObject ? (raw as { list?: unknown }).list : undefined;

  if (!Array.isArray(list)) {
    return { list: [], count: 0, degraded: true };
  }

  const rawCount = (raw as { count?: unknown }).count;
  const count = typeof rawCount === 'number' ? rawCount : list.length;

  return { list, count, degraded: false };
}
